var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"width":"100%","min-height":"20vh"}},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":4000,"size":90,"color":"#07D1BF"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }